/**
 * Filename: home.js
 * Home page
 * Component path
 * IconBoxed  'componenet/iconboxes.js'
 * Charts compoenent from 'compoenent/charts'
 * Table from 'containers/table.js'
 */

import React, {Component} from 'react';
import SidebarMenuRouters from "../../routers/routers.js";
import Header from '../../containers/header.js';
import ActionTools from '../../containers/actionTools.js';
import {Redirect} from 'react-router';
import { BUSINESS_UNIT, ROL } from '../../utils/constants';
import * as DataService from '../../service/data-info-chart/requestsUtil';

class SupervisorHome extends Component {

  constructor(props) {
    super(props);
    var userData = JSON.parse(localStorage.getItem("userData"));
    this.state = {userData: userData, kpis:''}
  }

  componentDidMount() {
    DataService.getFetch(BUSINESS_UNIT)
      .then((data) => {
        this.setState({
          kpis: data[0],
        });
      });
  }

  render() {
    var result;
    if (this.state.userData.rol === ROL.SUPERVISOR.url) {
      result = <div>
        <SidebarMenuRouters profile="/supervisor-home/" place={this.props.match.params.vp}/>
        <Header userName={this.state.userData.name}/>
        {/*<div className="vl"></div>*/}
        <ActionTools profile={'/profile-supervisor/place/'} place={this.props.match.params.vp} kpis={this.state.kpis}/>
      </div>
    } else {
      result = <Redirect to={"/"}/>
    }
    return (
      <div>
        {result}
      </div>
    );
  }
}

export default SupervisorHome;



// WEBPACK FOOTER //
// ./src/scene/supervisor/home.js